const footerLinks = [
  { name: "About Us", href: "/" },
  { name: "Contact", href: "/" },
  { name: "Blog", href: "/" },
  { name: "Careers", href: "/" },
  { name: "Support", href: "/" },
  { name: "Privacy Policy", href: "/" },
];

export default footerLinks;
